import { useEffect } from 'react';
// endpoints
import { authValidateToken } from 'endpoints/auth';
// utils
import { getAuthData } from 'utils/authData';

// Reloads the page when the current company was switched elsewhere.
// Stops polling once the session is gone, so an abandoned login tab does not hit the API every minute.
function CurrentUserCompanyManager({ user }) {
  useEffect(() => {
    if (user.root_companies.length > 1) {
      const interval = setInterval(async () => {
        if (!getAuthData().uid) {
          clearInterval(interval);
          return;
        }

        try {
          const { data: fetchedUser } = await authValidateToken();

          if (fetchedUser?.current_company?.id && fetchedUser.current_company.id !== user.current_company.id) {
            window.location.reload();
          }
        } catch (error) {
          // 401 clears the auth data, so the next tick stops the timer; a network blip just retries
          if (!getAuthData().uid) clearInterval(interval);
        }
      }, 60000); // 1 minute in milliseconds

      return () => clearInterval(interval);
    }
    return () => {};
  }, [user]);

  return null;
}

export default CurrentUserCompanyManager;
